import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinearProgress, {
  LinearProgressProps,
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { styled } from "@mui/material/styles";
import ellipsize from "ellipsize";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 8,
}));

type Props = LinearProgressProps & {
  value: number; // count
  label: string;
  barColor?: string;
  barBgColor?: string;
  percentage?: string | null;
};
const LinearProgressWithLabelAndCount = (props: Props) => {
  const clamp = (n: number) => Math.max(0, Math.min(100, n));
  const raw =
    props.percentage != null ? Number(props.percentage) : Number(props.value);

  // Handle NaN and clamp to 0–100
  const progressValue = Number.isFinite(raw) ? clamp(raw) : 0;
  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between mb-1">
        <p className="w-full text-sm font-normal leading-5 text-left text-gray-700 break-words dark:text-textMain font-Overpass">
          {ellipsize(props.label, 25)}
        </p>
        <p className="w-full text-sm font-normal leading-5 text-right text-gray-700 break-words dark:text-caption font-Overpass">
          {Math.round(props.value)}
        </p>
      </div>
      <div>
        <BorderLinearProgress
          variant="determinate"
          value={progressValue}
          sx={{
            [`&.${linearProgressClasses.colorPrimary}`]: {
              backgroundColor: props?.barBgColor || "#CDE7FF",
            },
            [`& .${linearProgressClasses.bar}`]: {
              borderRadius: 8,
              backgroundColor: props.barColor || "#11A3E2",
            },
          }}
        />
      </div>
    </div>
  );
};

export default LinearProgressWithLabelAndCount;
